import { BAOCustomElement } from '@bao/custom-element'
import { sectionRenderer } from '@bao/section-rendering'

class QuickBuy extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    try {
      const target = event.target
      const trigger = target.closest('[data-quick-buy-external-el="trigger"]')

      if (!trigger || trigger.getAttribute('aria-busy') === 'true') return

      trigger.setAttribute('aria-busy', true)

      const productUrl = trigger.dataset.productUrl

      const response = await sectionRenderer.fetchSingle(
        'drawer-quick-buy',
        productUrl,
      )

      const newDOM = sectionRenderer.convertToDOM(response)
      const bodyContent = newDOM.querySelector('.drw-QuickBuy')

      // Update body
      this.els.body.element.innerHTML = bodyContent.outerHTML
      trigger.setAttribute('aria-busy', false)

      window.drawers.activeDrawerKey = 'quick-buy'
    } catch (error) {
      window.drawers.activeDrawerKey = ''
      console.error(error)
    }
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
